import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-en-GB.json";
import resources from "./translations-en-GB.json";

setResources(resources, serverReference);